export const capitalFirstLetter = (str?: string | null) =>
  str && str?.length > 0 ? str.charAt(0).toUpperCase() + str.slice(1) : ''

export const splitAndCapitalizeEachWord = (str?: string | number | null) => {
  if (typeof str === 'number') return str.toString()
  if (!str || typeof str !== 'string') return ''

  return str
    .split('_')
    .map((word) => capitalFirstLetter(word?.toLowerCase() ?? ''))
    .join(' ')
}

export const splitAndCapitalFirstLetter = (str?: string | null) => {
  if (!str || typeof str !== 'string') return ''

  const replaced = str.replaceAll('_', ' ')

  return capitalFirstLetter(replaced)
}

export const formatNameWithLastInitial = (firstName?: string | null, lastName?: string | null): string => {
  const first = firstName?.trim()
  const last = lastName?.trim()

  if (!first && !last) return ''
  if (!first || first.length === 0) return last ?? ''
  if (!last || last.length === 0) return first

  const lastNameInitial = last.charAt(0).toUpperCase()

  return `${first} ${lastNameInitial}`
}
